//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/**
 * Enum denoting which merge template to query for.
 * **NOTE**
 * This is copied from Rock.Model.MergeTemplateOwnerShip to make accessible to other
 * areas of the codebase. If you make changes here, also update the original if applicable.
 */
export const MergeTemplateOwnership = {
    /** Show only global merge templates */
    Global: 0,

    /** Only show personal merge templates */
    Personal: 1,

    /** Show both personal and global merge templates */
    PersonalAndGlobal: 2
} as const;

/**
 * Enum denoting which merge template to query for.
 * **NOTE**
 * This is copied from Rock.Model.MergeTemplateOwnerShip to make accessible to other
 * areas of the codebase. If you make changes here, also update the original if applicable.
 */
export const MergeTemplateOwnershipDescription: Record<number, string> = {
    0: "Global",

    1: "Personal",

    2: "Personal And Global"
};

/**
 * Enum denoting which merge template to query for.
 * **NOTE**
 * This is copied from Rock.Model.MergeTemplateOwnerShip to make accessible to other
 * areas of the codebase. If you make changes here, also update the original if applicable.
 */
export type MergeTemplateOwnership = typeof MergeTemplateOwnership[keyof typeof MergeTemplateOwnership];
